import cookie from 'js-cookie';
import PageComponent from '../../common/component/page-component';


class RegionBanner extends PageComponent {

	constructor({
		root,
		element,
		closeAttribute = 'closeBanner',
		cookieNameAttribute = 'cookieName',
		closedClass = 'closed',
		cookieValue = 1,
		cookieExpireDays = 1
	}) {
		super({root: root, element: element});
		this.cookieNameAttribute = cookieNameAttribute;
		this.closeAttribute = closeAttribute;
		this.closedClass = closedClass;
		this.cookieValue = cookieValue;
		this.cookieExpireDays = cookieExpireDays;
	}


	prepare() {
		this.cookieName = this.dataAttr().get(this.cookieNameAttribute);
		this.listeners.click = this.events.on(this.element, this.dataSelector(this.closeAttribute), 'click', this.onClose.bind(this));
	}


	onClose(event) {
		this.classList().add(this.closedClass);
		cookie.set(this.cookieName, this.cookieValue, {expires: this.cookieExpireDays});
	}

}

export default RegionBanner;
